import { getDefaultConfiguration } from '@nv/contexts'

const getConfigurations = ({ t }) => {
  const defaultConfiguration = getDefaultConfiguration(t)

  return {
    ...defaultConfiguration,
    maxSessionTimeMinsAdmin: 2 * 60,
    modules: {
      nominations: true,
    },
  }
}
export default getConfigurations
